(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 79498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(38814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ buttonSize; },
/* harmony export */   "ZP": function() { return /* binding */ Button; },
/* harmony export */   "uX": function() { return /* binding */ buttonColor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(370);
/* harmony import */ var _basic_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84240);



var buttonColor = {
    primary: "text-white bg-gray-800 hover:bg-black focus:ring-gray-300 dark:text-gray-900 dark:bg-gray-50 dark:hover:bg-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 ",
    alternative: "text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    borderless: "text-gray-900 bg-white hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    danger: "text-white bg-red-700 hover:bg-red-800 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900",
    link: "underline hover:no-underline active:no-underline focus:no-underline cursor-pointer text-gray-800 underline-offset-2 dark:text-gray-300",
    transparent: "bg-transparent focus:ring-transparent p-0"
};
var buttonSize = {
    "no-size": "p-0 m-0",
    "extra-small": "py-2 px-3 text-xs ",
    small: "py-2 px-3 text-sm ",
    base: "px-2 lg:px-5 py-2 lg:py-2.5 text-sm",
    large: "py-3 px-5 text-base",
    "extra-large": "px-6 py-3.5 text-base "
};
function Button(param) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "primary" : _color, _size = param.size, size = _size === void 0 ? "base" : _size, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingMessage = param.loadingMessage, loadingMessage = _loadingMessage === void 0 ? "" : _loadingMessage, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? loading : _disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(buttonColor[color], buttonSize[size], "font-bold rounded-lg focus:z-10 focus:ring-2", className, {
            "flex items-center justify-center gap-3": loading
        }),
        type: type,
        onClick: onClick,
        disabled: disabled,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "!w-6 !h-6"
                }),
                loadingMessage
            ]
        }) : children
    });
}


/***/ }),

/***/ 4683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Label(param) {
    var htmlFor = param.htmlFor, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: htmlFor,
        className: "block mb-2 text-sm font-bold text-gray-900 dark:text-gray-300 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 45214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99730);




var states = {
    primary: "bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ",
    error: ""
};
var errorClass = "bg-red-100 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-red-100 dark:border-red-400";
function TextInput(param) {
    var id = param.id, name = param.name, _type = param.type, type = _type === void 0 ? "text" : _type, _state = param.state, state = _state === void 0 ? "primary" : _state, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, className = param.className, register = param.register, onChange = param.onChange, placeholder = param.placeholder, min = param.min, max = param.max, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                id: id
            }, onChange && {
                onChange: onChange
            }, register && register(name)), {
                disabled: disabled,
                type: type,
                placeholder: placeholder,
                className: "".concat(states[state], " ").concat(errorText ? errorClass : "", " ").concat(disabled ? "text-gray-500" : "", " shadow-sm border text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:shadow-sm-light ").concat(className)
            }), min && {
                min: min
            }, max && {
                max: max
            }, value && {
                value: value
            })),
            errorText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                variant: "error",
                className: "mt-2 text-sm text-red-600 dark:text-red-500",
                children: errorText
            }) : ""
        ]
    });
}


/***/ }),

/***/ 39591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XO": function() { return /* binding */ ErrorMessages; }
/* harmony export */ });
/* unused harmony exports PublicationErrorMessages, PostErrorMessages */
var ErrorMessages;
(function(ErrorMessages) {
    ErrorMessages["UNAUTHORIZED"] = "Vous devez \xeatre connect\xe9 pour acc\xe8der \xe0 cette page";
    ErrorMessages["MALFORMED_URL"] = "Votre url n'est pas bien form\xe9e";
    ErrorMessages["INTERNAL_ERROR"] = "Une erreur est survenue, veuillez ressayer plus tard";
})(ErrorMessages || (ErrorMessages = {}));
var PublicationErrorMessages;
(function(PublicationErrorMessages) {
    PublicationErrorMessages["NOT_FOUND"] = "Aucune publication n'a \xe9t\xe9 trouv\xe9e";
})(PublicationErrorMessages || (PublicationErrorMessages = {}));
var PostErrorMessages;
(function(PostErrorMessages) {
    PostErrorMessages["NOT_FOUND"] = "Aucun article n'a \xe9t\xe9 trouv\xe9";
})(PostErrorMessages || (PostErrorMessages = {}));


/***/ }),

/***/ 38814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Register; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87536);
/* harmony import */ var _components_elements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74340);
/* harmony import */ var _components_elements_Forms_Label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4683);
/* harmony import */ var _components_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45214);
/* harmony import */ var _components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51859);
/* harmony import */ var _components_elements_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6553);
/* harmony import */ var _components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99730);
/* harmony import */ var _components_modules_Layout_BasicLayout_BasicCardLayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6475);
/* harmony import */ var _components_modules_Seo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12400);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6635);
/* harmony import */ var _features_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15768);
/* harmony import */ var _features_user__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68543);
/* harmony import */ var _lib_errorMessages__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39591);





















function handleRegister(_) {
    return _handleRegister.apply(this, arguments);
}
function _handleRegister() {
    _handleRegister = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var email, password, router, setIsLoading, setIsError, setErrorMessage, error, ref, ref1, ref2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = param.email, password = param.password, router = param.router, setIsLoading = param.setIsLoading, setIsError = param.setIsError, setErrorMessage = param.setErrorMessage;
                    setIsError(false);
                    setIsLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        6
                    ]);
                    return [
                        4,
                        (0,_features_user__WEBPACK_IMPORTED_MODULE_14__/* .signUp */ .y1)(email, password)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        router.push({
                            pathname: _config_routes__WEBPACK_IMPORTED_MODULE_12__/* ["default"].checkEmail.getUrl */ .Z.checkEmail.getUrl(),
                            query: {
                                email: email
                            }
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    error = _state.sent();
                    setIsError(true);
                    if (axios__WEBPACK_IMPORTED_MODULE_1___default().isAxiosError(error)) {
                        ;
                        if (((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) === "Email or Username are already taken") {
                            setErrorMessage("Impossible de cr\xe9er le compte. V\xe9rifie que vous n'\xeates pas d\xe9j\xe0 enregistr\xe9 avec cet email");
                            return [
                                2
                            ];
                        }
                    }
                    setErrorMessage(_lib_errorMessages__WEBPACK_IMPORTED_MODULE_15__/* .ErrorMessages.INTERNAL_ERROR */ .XO.INTERNAL_ERROR);
                    console.error(error);
                    return [
                        3,
                        6
                    ];
                case 5:
                    setIsLoading(false);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleRegister.apply(this, arguments);
}
var __N_SSP = true;
function Register(param) {
    var prefilledEmail = param.prefilledEmail;
    var onSubmit = function onSubmit(param) {
        var email = param.email, password = param.password;
        handleRegister({
            email: email,
            password: password,
            router: router,
            setIsLoading: setIsLoading,
            setIsError: setIsError,
            setErrorMessage: setErrorMessage
        });
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isError = ref1[0], setIsError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_18__/* .useForm */ .cI)({
        defaultValues: {
            email: prefilledEmail || "",
            password: ""
        }
    }), register = ref3.register, handleSubmit = ref3.handleSubmit;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_modules_Layout_BasicLayout_BasicCardLayout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_Seo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Cr\xe9er un compte",
                description: "Inscrivez-vous sur Partager et retrouvez vos auteurs et publications pr\xe9f\xe9r\xe9es.",
                url: _config_routes__WEBPACK_IMPORTED_MODULE_12__/* ["default"].register.getUrl */ .Z.register.getUrl(),
                isCanonical: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "!mt-0",
                level: 1,
                children: "S’inscrire"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_Label__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                htmlFor: "login-email",
                                children: "Adresse e-mail"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                id: "login-email",
                                type: "email",
                                className: "w-full",
                                name: "email"
                            }, prefilledEmail && {
                                disabled: true
                            }), {
                                register: register
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_Label__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                htmlFor: "login-password",
                                children: "Mot de passe"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                id: "login-password",
                                type: "password",
                                className: "w-full",
                                name: "password",
                                register: register
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        type: "submit",
                        className: "!w-full mb-6",
                        loading: isLoading,
                        children: "Suivant"
                    }),
                    isError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "error",
                        className: "text-center",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "text-center mb-6",
                children: "Ou"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "!w-full mb-6",
                color: "alternative",
                onClick: function() {
                    return (0,_features_auth__WEBPACK_IMPORTED_MODULE_13__/* .googleSignIn */ .nS)();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        width: "24",
                        height: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "inline-block mr-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#4285F4",
                                    d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#34A853",
                                    d: "M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#FBBC05",
                                    d: "M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#EA4335",
                                    d: "M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"
                                })
                            ]
                        })
                    }),
                    "Se connecter avec Google"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "text-center",
                children: [
                    "Vous avez un compte? ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        href: _config_routes__WEBPACK_IMPORTED_MODULE_12__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                        children: "Connectez-vous"
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5525,1664,7536,6904,6193,9774,2888,179], function() { return __webpack_exec__(79498); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);